import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavV6 } from '../../nav/useNavV6';
import SubTabs from '../../nav/SubTabs';

/**
 * QR Loyalty — in-panel navigation for the owner mini-app. A back breadcrumb to
 * the dashboard + Honey & Ink chips (Settings / Rewards / Featured Items) with a
 * honey-gradient active state. Rendered INSIDE .lty-app so it's themed and can't
 * be missed (replaces the global SectionChipBar entry for /loyalty).
 */
export default function LoyaltyNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const navV6 = useNavV6(); // new navigation: the page sits inside the platform shell, so the way back is the sidebar

  const chips = [
    { to: '/loyalty/settings', label: t('nav.loyalty_settings') },
    { to: '/loyalty/rewards', label: t('nav.loyalty_rewards') },
    { to: '/loyalty/featured-items', label: t('nav.loyalty_featured') },
    { to: '/loyalty/analytics', label: t('nav.loyalty_analytics') },
  ];
  // Treat the bare /loyalty route (renders Settings) as the Settings chip.
  const isActive = (to) => pathname === to || (to === '/loyalty/settings' && pathname === '/loyalty');

  if (navV6) {
    // new navigation: level 2 is the shared compact row (never the boxed, wrapping chips)
    return (
      <div className="lty-nav">
        <SubTabs ariaLabel={t('nav.loyalty')} items={chips.map((c) => ({ id: c.to, to: c.to, label: c.label, active: isActive(c.to) }))} />
      </div>
    );
  }

  return (
    <div className="lty-nav">
      {!navV6 && (
        <button type="button" className="lty-back" onClick={() => navigate('/dashboard')}>
          <i className="pi pi-arrow-left" />
          <span>{t('loyalty.back_dashboard')}</span>
        </button>
      )}
      <nav className="lty-chips">
        {chips.map((c) => (
          <NavLink key={c.to} to={c.to} className={`lty-chip${isActive(c.to) ? ' active' : ''}`}>
            {c.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
